import getServiceTeams from "@fartherfinance/frontend/api/Entity/requests/getServiceTeams";
import { AdvisorRequestConfig } from "@fartherfinance/frontend/api/Types";

import {
  EnumOption,
  isResourceTypeWithValue,
  ResourceTypeResponse,
} from "../../core/types";

import { cache5Min } from "./cache";

export const fetchServiceTeams = async (
  requestConfig: AdvisorRequestConfig,
  values: ResourceTypeResponse[]
): Promise<EnumOption[]> => {
  if (
    !Array.isArray(values) ||
    !values.every((value) => isResourceTypeWithValue(value)) ||
    values.length === 0
  ) {
    return [];
  }

  const serviceTeams = await cache5Min("serviceTeam", () =>
    getServiceTeams({
      jwt: requestConfig.jwt,
      advisorId: requestConfig.advisorId,
    })
  );

  if (!serviceTeams) {
    return [];
  }

  const serviceTeamIds = values
    .filter(isResourceTypeWithValue)
    .map((param) => param.value);

  const serviceTeamOptions = serviceTeams
    .filter((team) => serviceTeamIds.includes(team.serviceTeamId))
    .map((team) => {
      const resolvedResource = values.find(
        (param) =>
          isResourceTypeWithValue(param) && param.value === team.serviceTeamId
      );
      if (!resolvedResource || !isResourceTypeWithValue(resolvedResource)) {
        return null;
      }

      return {
        type: resolvedResource.type,
        kind: resolvedResource.kind,
        label: team.name,
        value: String(team.serviceTeamId),
      };
    })
    .filter(
      (option): option is Exclude<typeof option, null> => option !== null
    );

  return serviceTeamOptions as EnumOption[];
};
